import { useState } from 'react';
import { Frame } from '@/components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RuntimeError = ({
  error
}) => {
  const [isCollapsed, setIsCollapsed] = useState(error.frames.length > 1);
  return /*#__PURE__*/_jsxs("div", {
    className: "ima-runtime-error",
    children: [(isCollapsed ? [error.frames[0]] : error.frames).map(frame => /*#__PURE__*/_jsx(Frame, {
      frame: frame,
      type: error.type
    }, `${frame.fileName}${frame.line}${frame.column}`)), isCollapsed && /*#__PURE__*/_jsx("div", {
      className: "ima-runtime-error__expand-wrapper",
      children: /*#__PURE__*/_jsxs("button", {
        type: "button",
        className: "ima-runtime-error__expand-button",
        onClick: () => setIsCollapsed(!isCollapsed),
        children: ["Show", ' ', /*#__PURE__*/_jsx("span", {
          className: "ima-runtime-error__number",
          children: error.frames.length - 1
        }), ' ', "hidden stack frames"]
      })
    })]
  });
};
export default RuntimeError;